/**
 * Barre sticky « Ajouter au panier » (PDP).
 * Visible en bas d’écran quand le CTA principal sort du viewport ;
 * disparaît dès qu’on scroll dessus, réapparaît ensuite.
 */
(function () {
  'use strict';

  function initStickyAtc() {
    var bar = document.getElementById('seo-pdp-sticky-atc');
    if (!bar || bar.dataset.seoStickyBound === '1') return;

    var form =
      document.querySelector('product-form form.shopify-product-form') ||
      document.querySelector('product-form form');
    var mainBtn =
      form && form.querySelector('button[name="add"], input[type="submit"][name="add"]');
    if (!mainBtn) return;

    bar.dataset.seoStickyBound = '1';

    // Sortir du stacking context de la section produit (sinon footer / sections
    // suivantes peignent par-dessus le fixed z-index).
    if (bar.parentElement !== document.body) {
      document.body.appendChild(bar);
    }

    // Ne pas observer .product-form-buttons__row : souvent display:contents → rect 0.
    var observeTarget =
      mainBtn.closest('.add-to-cart-component') ||
      mainBtn.closest('.product-form__buttons') ||
      mainBtn;

    var footerInView = false;
    var checkByRectRef = function () {};

    function isChromeOverlayOpen() {
      if (document.querySelector('product-modal[open]')) return true;
      if (document.querySelector('#shopify-menu-drawer > details.menu-drawer_details[open]')) return true;
      if (document.querySelector('#shopify-menu-drawer > details.menu-opening')) return true;
      if (document.querySelector('details.minicart[open], details.minicart-popup[open]')) return true;
      if (document.body.classList.contains('pebble-search-open')) return true;
      if (document.body.classList.contains('header-search-open')) return true;
      if (document.querySelector('#shopify-header-section.header--pebble-search-open')) return true;
      if (document.querySelector('#shopify-header-section.header--floating-search-open')) return true;
      if (document.querySelector('#SearchModal[open], modal-dialog.search-popup-modal[open]')) return true;
      return false;
    }

    function syncOverlayState() {
      var open = isChromeOverlayOpen();
      var changed = document.body.classList.contains('seo-pdp-overlay-open') !== open;
      document.body.classList.toggle('seo-pdp-overlay-open', open);
      document.body.classList.toggle('seo-pdp-minicart-open', open);
      if (changed) checkByRectRef();
    }

    function bindOverlayToggles() {
      var nodes = document.querySelectorAll(
        '#shopify-menu-drawer > details.menu-drawer_details, details.minicart, details.minicart-popup'
      );
      nodes.forEach(function (details) {
        if (details.dataset.seoStickyOverlayBound === '1') return;
        details.dataset.seoStickyOverlayBound = '1';
        details.addEventListener('toggle', syncOverlayState);
      });
    }

    bindOverlayToggles();
    syncOverlayState();
    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(syncOverlayState).observe(document.body, {
        attributes: true,
        attributeFilter: ['class']
      });
      var headerSection = document.getElementById('shopify-header-section');
      if (headerSection) {
        new MutationObserver(syncOverlayState).observe(headerSection, {
          attributes: true,
          attributeFilter: ['class']
        });
      }
    }

    function isPrivacyBannerOpen() {
      var el = document.getElementById('shopify-pc__banner');
      if (!el) return false;
      var st = window.getComputedStyle(el);
      if (st.display === 'none' || st.visibility === 'hidden' || Number(st.opacity) === 0) {
        return false;
      }
      var r = el.getBoundingClientRect();
      return r.height > 8 && r.bottom > 0 && r.top < (window.innerHeight || 0);
    }

    function syncPrivacyBannerState() {
      document.body.classList.toggle('seo-pdp-privacy-banner-open', isPrivacyBannerOpen());
      checkByRectRef();
    }

    function bindPrivacyBannerObserver() {
      var el = document.getElementById('shopify-pc__banner');
      if (!el || el.dataset.seoStickyPrivacyBound === '1') return;
      el.dataset.seoStickyPrivacyBound = '1';
      if (typeof MutationObserver === 'undefined') return;
      new MutationObserver(syncPrivacyBannerState).observe(el, {
        attributes: true,
        attributeFilter: ['hidden', 'style', 'class', 'aria-hidden']
      });
    }

    syncPrivacyBannerState();
    bindPrivacyBannerObserver();
    var privacyTries = 0;
    var privacyTimer = setInterval(function () {
      bindPrivacyBannerObserver();
      syncPrivacyBannerState();
      privacyTries += 1;
      if (document.getElementById('shopify-pc__banner') || privacyTries > 40) {
        clearInterval(privacyTimer);
      }
    }, 250);
    document.addEventListener('visitorConsentCollected', syncPrivacyBannerState);

    var stickyBtn = bar.querySelector('[data-seo-sticky-atc-btn]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (!mainBtn.disabled) mainBtn.click();
      });
    }

    function syncStickyButtonState() {
      if (!stickyBtn) return;
      stickyBtn.disabled = mainBtn.disabled;
      var labelEl = stickyBtn.querySelector('.seo-pdp-sticky-atc__btn-label');
      var mainLabel = mainBtn.querySelector(
        '.add-to-cart-text__content, .add-to-cart-button__label, .btn__text, span'
      );
      if (labelEl && mainLabel) {
        labelEl.textContent = (mainLabel.textContent || '').trim();
      }
    }

    syncStickyButtonState();
    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(syncStickyButtonState).observe(mainBtn, {
        attributes: true,
        attributeFilter: ['disabled', 'class'],
        childList: true,
        subtree: true
      });
    }

    var io;
    var footerIo;

    function resolveFooterEl() {
      return (
        document.querySelector('footer') ||
        document.querySelector('.shopify-section-group-footer-group') ||
        document.querySelector('.shopify-section.footer')
      );
    }

    function readFooterInView() {
      var footer = resolveFooterEl();
      if (!footer) return false;
      var r = footer.getBoundingClientRect();
      var vh = window.innerHeight || 0;
      return r.top < vh && r.bottom > 0;
    }

    function connectFooterIO() {
      if (footerIo) {
        footerIo.disconnect();
        footerIo = null;
      }
      var footer = resolveFooterEl();
      if (!footer) {
        footerInView = false;
        document.body.classList.remove('seo-pdp-footer-inview');
        return;
      }
      if (typeof IntersectionObserver === 'undefined') return;
      footerIo = new IntersectionObserver(
        function (entries) {
          var e = entries[0];
          footerInView = !!(e && e.isIntersecting) || readFooterInView();
          document.body.classList.toggle('seo-pdp-footer-inview', footerInView);
          checkByRectRef();
        },
        { root: null, threshold: 0, rootMargin: '0px 0px 1px 0px' }
      );
      footerIo.observe(footer);
    }

    function setStickyVisibility(show) {
      if (isChromeOverlayOpen()) show = false;
      if (document.body.classList.contains('seo-pdp-privacy-banner-open')) show = false;
      if (footerInView) show = false;

      if (show) {
        bar.classList.add('is-visible');
        bar.removeAttribute('hidden');
        bar.setAttribute('aria-hidden', 'false');
        document.body.classList.add('seo-pdp-sticky-atc-open');
      } else {
        bar.classList.remove('is-visible');
        bar.setAttribute('hidden', '');
        bar.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('seo-pdp-sticky-atc-open');
      }
    }

    function onIntersect() {
      checkByRect();
    }

    function connectIO() {
      if (io) {
        io.disconnect();
        io = null;
      }
      if (typeof IntersectionObserver === 'undefined') {
        setStickyVisibility(true);
        return;
      }
      io = new IntersectionObserver(onIntersect, {
        root: null,
        threshold: 0,
        rootMargin: '0px 0px -12px 0px'
      });
      io.observe(observeTarget);
    }

    connectIO();
    connectFooterIO();
    window.addEventListener(
      'resize',
      function () {
        connectIO();
        connectFooterIO();
        syncPrivacyBannerState();
        syncOverlayState();
        checkByRect();
      },
      { passive: true }
    );

    // Filet de sécurité : recalcule aussi au scroll (IO parfois silencieux)
    var scrollTicking = false;
    function checkByRect() {
      scrollTicking = false;
      footerInView = readFooterInView();
      document.body.classList.toggle('seo-pdp-footer-inview', footerInView);
      if (!observeTarget) {
        setStickyVisibility(false);
        return;
      }
      var r = observeTarget.getBoundingClientRect();
      var vh = window.innerHeight || 0;
      var inView = r.bottom > 12 && r.top < vh - 12 && r.height > 0;
      setStickyVisibility(!inView);
    }
    checkByRectRef = checkByRect;
    window.addEventListener(
      'scroll',
      function () {
        if (scrollTicking) return;
        scrollTicking = true;
        window.requestAnimationFrame(checkByRect);
      },
      { passive: true }
    );
    if (window.visualViewport) {
      window.visualViewport.addEventListener(
        'scroll',
        function () {
          if (scrollTicking) return;
          scrollTicking = true;
          window.requestAnimationFrame(checkByRect);
        },
        { passive: true }
      );
    }
    checkByRect();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtc);
  } else {
    initStickyAtc();
  }
  document.addEventListener('shopify:section:load', initStickyAtc);
})();
